/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 7
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/cdk/Dealer%20Onboarding/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/cdk/Dealer%20Onboarding/implementation/web)
 */

import * as amplitude from "@amplitude/analytics-browser";

export type Environment = "production" | "development";

export const ApiKey: Record<Environment, string> = {
  production: "e546336607dc04684168c229e25a808e",
  development: "c757f73350b68446d1f71f5523e0d0ae",
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: "7",
    branch: "main",
    source: "web",
    versionId: "db350833-c4c8-4a34-a5f4-d4d084e3164b",
  },
  ...{
    ingestionMetadata: {
      sourceName: "browser-typescript-ampli",
      sourceVersion: "2.0.0",
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  "Department ID"?: string;
  /**
   * User property designating the Enterprise ID of the logged in user
   */
  "Enterprise ID"?: string;
  Role?: string;
  "Store ID"?: string;
  "Store Name"?: string;
}

export interface ClosePortalProperties {
  /**
   * This property gives the location of where the event is happening.
   */
  "Company Header"?: string;
  /**
   * The property describes the action taken from the event prompt.
   */
  "Prompt Action"?: string;
  /**
   * The property should measure the length of time the user was logged in before deciding to clost the portal.
   */
  "Session Duration": string;
}

export interface OpenCdcmPortalProperties {
  /**
   * This property specifies which source destination the user originated from.
   */
  "Referring Domain"?: string;
  /**
   * This property describes when the users begins a session in the portal.
   */
  "Start Session": string;
}

export interface PerformSearchProperties {
  "Entry Name"?: string;
  "Search Bar"?: boolean;
}

export interface SelectRecordProperties {
  /**
   * The property triggers when a user select record and a unique identifier is recognized.
   */
  "Record ID"?: string;
}

export interface CreateRecordProperties {
  "Save Record"?: boolean;
  Action?: string;
  "Action Triggered": boolean;
  Store: string;
  Application: string;
  Setup: string;
  "Record Created"?: any;
}

export interface DeleteRecordProperties {
  "Delete Record"?: boolean;
  Action?: string;
  "Action Triggered": boolean;
  Store: string;
  Application: string;
  Setup: string;
  "Record Deleted"?: any;
}

export interface CancelEventProperties {
  "Cancel Button Clicked": boolean;
}

export interface SaveEventProperties {
  /**
   * Properties for the Save event.
   * This interface identifies details about the save action.
   */
  setupName?: string;
  selectedTabSectionKey?: string;
}

export interface EntryActionProperties {
  Action:
    | "View Entry"
    | "Edit Entry"
    | "Copy New Entry"
    | "Delete Entry"
    | "New Entry";
  "Action Triggered": boolean;
  Store: string;
  Application: string;
  Setup: string;
}

export interface NewEntryEventProperties {
  "Event Name"?: string;
  "Action Triggered": boolean;
}

export interface DateRangeEventProperties {
  startDate?: string;
  endDate?: string;
}

export interface OpenEventProperties {
  reason?: string;
}

export interface CloseEventProperties {
  reason?: string;
}

export interface ResetEventProperties {
  section?: string;
  triggeredBy?: string;
  reason?: string;
}

export interface ClearChangeEventProperties {
  "Event Name"?: string;
  "Action Triggered": boolean;
}

export interface ImportGroupCodesClickEventProperties {
  "Open Import Group Codes Dialog Popup": boolean;
}

export interface CopyPOUnitsOfMeasureEventProperties {
  "Open Copy PO Units of Measure Dialog Popup": boolean;
}

export interface ImportButtonClickEventProperties {
  "Import Group Codes": boolean;
  "Source Store"?: string;
  "Group Code Type"?: string;
  "Selected Group Codes"?: string[];
}

export interface CopyPOUnitsOfMeasureButtonClickEventProperties {
  "Copy PO Units of Measure": boolean;
  "Source Store"?: string;
  "Destination Store"?: string;
  "Selected PO Units of Measure"?: string;
}

export interface SearchButtonClickProperties {
  "Search Button Clicked": boolean;
  Store: string;
  Application: string;
  Setup: string;
}

export interface DownloadIconClickProperties {
  "Open Download Popup": boolean;
}

export interface DownloadButtonClickProperties {
  "Download Records": boolean;
  exportType?: "Excel (.xlsx)" | "CSV (.csv)";
}

export interface SearchSetupsProperties {
  "Search Bar Clicked": boolean;
  Setup?: string;
}

export interface SelectNavigationProperties {
  "Navigation Item Clicked": boolean;
  "Navigation Section"?: string;
  "Navigation Item": string;
  Setup?: string;
}

export interface SaveFavoritesProperties {
  "Added Setups"?: string[];
  "Removed Setups"?: string[];
}

export interface OpenSetupProperties {
  "Setup Name"?: string;
  Department?: string;
  "Is Favorite"?: boolean;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(public event_properties?: IdentifyProperties) {
    this.event_properties = event_properties;
  }
}

export class ClosePortal implements BaseEvent {
  event_type = "Close Portal";

  constructor(public event_properties: ClosePortalProperties) {
    this.event_properties = event_properties;
  }
}

export class CreateRecord implements BaseEvent {
  event_type = "Save Record";

  constructor(public event_properties?: CreateRecordProperties) {
    this.event_properties = event_properties;
  }
}

export class DeleteRecord implements BaseEvent {
  event_type = "Delete Record";

  constructor(public event_properties?: DeleteRecordProperties) {
    this.event_properties = event_properties;
  }
}

export class OpenCdcmPortal implements BaseEvent {
  event_type = "Open CDCM Portal";

  constructor(public event_properties: OpenCdcmPortalProperties) {
    this.event_properties = event_properties;
  }
}

export class PerformSearch implements BaseEvent {
  event_type = "Perform Search";

  constructor(public event_properties?: PerformSearchProperties) {
    this.event_properties = event_properties;
  }
}

export class SelectRecord implements BaseEvent {
  event_type = "Select Record";

  constructor(public event_properties?: SelectRecordProperties) {
    this.event_properties = event_properties;
  }
}

export class CancelEvent implements BaseEvent {
  event_type = "Cancel";

  constructor(public event_properties?: CancelEventProperties) {
    this.event_properties = event_properties;
  }
}

export class SaveEvent implements BaseEvent {
  event_type = "Save";

  constructor(public event_properties?: SaveEventProperties) {
    this.event_properties = event_properties;
  }
}

export class EntryActionEvent implements BaseEvent {
  event_type = "Event Action";

  constructor(public event_properties?: EntryActionProperties) {
    this.event_properties = event_properties;
  }
}
export class NewEntryEvent implements BaseEvent {
  event_type = "New Entry";

  constructor(public event_properties?: NewEntryEventProperties) {
    this.event_properties = event_properties;
  }
}

export class ClearChangeEvent implements BaseEvent {
  event_type = "Clear Changes";

  constructor(public event_properties?: ClearChangeEventProperties) {
    this.event_properties = event_properties;
  }
}

export class DateRangeEvent implements BaseEvent {
  event_type = "Date Range Selected";

  constructor(public event_properties?: DateRangeEventProperties) {
    this.event_properties = event_properties;
  }
}

export class OpenEvent implements BaseEvent {
  event_type = "Open";

  constructor(public event_properties?: OpenEventProperties) {
    this.event_properties = event_properties;
  }
}

export class CloseEvent implements BaseEvent {
  event_type = "Close";

  constructor(public event_properties?: CloseEventProperties) {
    this.event_properties = event_properties;
  }
}

export class ResetEvent implements BaseEvent {
  event_type = "Reset";
  constructor(public event_properties?: ResetEventProperties) {
    this.event_properties = event_properties;
  }
}

export class SearchButtonClick implements BaseEvent {
  event_type = "Search Button Click";

  constructor(public event_properties?: SearchButtonClickProperties) {
    this.event_properties = event_properties;
  }
}

export class DownloadIconClick implements BaseEvent {
  event_type = "Open Download Popup";

  constructor(public event_properties?: DownloadIconClickProperties) {
    this.event_properties = event_properties;
  }
}

export class ImportGroupCodesDialogPopup implements BaseEvent {
  event_type = "Open Import Group Codes Dialog Popup";

  constructor(public event_properties?: ImportGroupCodesClickEventProperties) {
    this.event_properties = event_properties;
  }
}

export class ImportButtonClick implements BaseEvent {
  event_type = "Import Group Codes";

  constructor(public event_properties?: ImportButtonClickEventProperties) {
    this.event_properties = event_properties;
  }
}

export class CopyPOUnitsOfMeasureDialogPopup implements BaseEvent {
  event_type = "Open Copy PO Units of Measure Dialog Popup";

  constructor(public event_properties?: CopyPOUnitsOfMeasureEventProperties) {
    this.event_properties = event_properties;
  }
}
export class CopyPOUnitsOfMeasureButtonClick implements BaseEvent {
  event_type = "Copy PO Units of Measure";

  constructor(
    public event_properties?: CopyPOUnitsOfMeasureButtonClickEventProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DownloadButtonClick implements BaseEvent {
  event_type = "Download Records";

  constructor(public event_properties?: DownloadButtonClickProperties) {
    this.event_properties = event_properties;
  }
}

export class SearchSetups implements BaseEvent {
  event_type = "Search Setups";

  constructor(public event_properties?: SearchSetupsProperties) {
    this.event_properties = event_properties;
  }
}

export class SelectNavigation implements BaseEvent {
  event_type = "Select Navigation";

  constructor(public event_properties?: SelectNavigationProperties) {
    this.event_properties = event_properties;
  }
}

export class SaveFavorites implements BaseEvent {
  event_type = "Save Favorite Setups";

  constructor(public event_properties?: SaveFavoritesProperties) {
    this.event_properties = event_properties;
  }
}

export class OpenSetup implements BaseEvent {
  event_type = "Open Setup";

  constructor(public event_properties?: OpenSetupProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Close Portal
   *
   * [View in Tracking Plan](https://data.amplitude.com/cdk/Dealer%20Onboarding/events/main/latest/Close%20Portal)
   *
   * This event is triggered when the user clicks Sign Out button to close the portal interface.
   *
   * @param properties The event's properties (e.g. Company Header)
   * @param options Amplitude event options.
   */
  closePortal(
    properties: ClosePortalProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClosePortal(properties), options);
  }

  /**
   * Create Record
   *
   * [View in Tracking Plan](https://data.amplitude.com/cdk/Dealer%20Onboarding/events/main/latest/Create%20Record)
   *
   * Event should fire when a user selects the New Entry button to create a new record
   *
   *
   *
   *
   * Owner: Dawn Jordan
   *
   * @param properties The event's properties (e.g. Column Selections)
   * @param options Amplitude event options.
   */
  createRecord(
    properties?: CreateRecordProperties,
    options?: EventOptions,
  ) {
    return this.track(new CreateRecord(properties), options);
  }

  /**
   * Delete Record
   *
   * [View in Tracking Plan](https://data.amplitude.com/cdk/Dealer%20Onboarding/events/main/latest/Delete%20Record)
   *
   * Event should fire when a user deletes a record
   *
   *
   *
   *
   * Owner: Dawn Jordan
   *
   * @param properties The event's properties (e.g. Column Selections)
   * @param options Amplitude event options.
   */
  deleteRecord(
    properties?: DeleteRecordProperties,
    options?: EventOptions,
  ) {
    return this.track(new DeleteRecord(properties), options);
  }

  /**
   * Open CDCM Portal
   *
   * [View in Tracking Plan](https://data.amplitude.com/cdk/Dealer%20Onboarding/events/main/latest/Open%20CDCM%20Portal)
   *
   *
   * This event is triggered when the user arrives at the CDCM landing page from various origin points.
   *
   * Owner: Dawn Jordan
   *
   * @param properties The event's properties (e.g. Referring Domain)
   * @param options Amplitude event options.
   */
  openCdcmPortal(
    properties: OpenCdcmPortalProperties,
    options?: EventOptions,
  ) {
    return this.track(new OpenCdcmPortal(properties), options);
  }

  /**
   * Perform Search
   *
   * [View in Tracking Plan](https://data.amplitude.com/cdk/Dealer%20Onboarding/events/main/latest/Perform%20Search)
   *
   * This is Step 4 in the process and is triggered with the user performs a search to find a specific record in the portal. User may conduct search via the Search field or by selecting the filter option (three-lines icon)  in a column.
   *
   * @param properties The event's properties (e.g. Column Search)
   * @param options Amplitude event options.
   */
  performSearch(
    properties?: PerformSearchProperties,
    options?: EventOptions,
  ) {
    return this.track(new PerformSearch(properties), options);
  }

  /**
   * Select Record
   *
   * [View in Tracking Plan](https://data.amplitude.com/cdk/Dealer%20Onboarding/events/main/latest/Select%20Record)
   *
   * This event is triggered when the user select a record from the grid.
   *
   * Owner: Dawn Jordan
   *
   * @param properties The event's properties (e.g. Record ID)
   * @param options Amplitude event options.
   */
  selectRecord(
    properties?: SelectRecordProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectRecord(properties), options);
  }

  cancel(
  properties?: CancelEventProperties,
  options?: EventOptions,
  ) {
    return this.track(new CancelEvent(properties), options);
  }

  save(
  properties?: SaveEventProperties,
  options?: EventOptions,
  ) {
    return this.track(new SaveEvent(properties), options);
  }

  entryAction(
  properties?: EntryActionProperties,
    options?: EventOptions
  ) {
    return this.track(new EntryActionEvent(properties), options);
  }

  dateRangeSelected(
  properties?: DateRangeEventProperties,
  options?: EventOptions,
  ) {
    return this.track(new DateRangeEvent(properties), options);
  }

  open(
  properties?: OpenEventProperties,
  options?: EventOptions,
  ) {
    return this.track(new OpenEvent(properties), options);
  }

  closeButtonClick(
  properties?: CloseEventProperties,
  options?: EventOptions,
  ) {
    return this.track(new CloseEvent(properties), options);
  }

  reset(properties?: ResetEventProperties, options?: any) {
    return this.track(new ResetEvent(properties), options);
  }

  clearChange(
  properties?: ClearChangeEventProperties,
  options?: EventOptions
  ) {
  return this.track(new ClearChangeEvent(properties), options);
  }

  newEntry(
  properties?: NewEntryEventProperties,
  options?: EventOptions
  ) {
  return this.track(new NewEntryEvent(properties), options);
  }

  searchButtonClick(
  properties?: SearchButtonClickProperties,
  options?: EventOptions
  ) {
  return this.track(new SearchButtonClick(properties), options);
  }

  downloadIconClick(
  properties?: DownloadIconClickProperties,
  options?: EventOptions
  ) {
  return this.track(new DownloadIconClick(properties), options);
  }

  importGroupCodesDialogPopup(
  properties?: ImportGroupCodesClickEventProperties,
  options?: EventOptions
  ) {
  return this.track(new ImportGroupCodesDialogPopup(properties), options);
  }

  importButtonClick(
  properties?: ImportButtonClickEventProperties,
  options?: EventOptions
  ) {
  return this.track(new ImportButtonClick(properties), options);
  }

  copyPOUnitsOfMeasureButtonClick(
  properties?: CopyPOUnitsOfMeasureButtonClickEventProperties,
  options?: EventOptions
  ) {
  return this.track(new CopyPOUnitsOfMeasureButtonClick(properties), options);
  }

  copyPOUnitsOfMeasureDialogPopup(
  properties?: CopyPOUnitsOfMeasureEventProperties,
  options?: EventOptions
  ) {
  return this.track(new CopyPOUnitsOfMeasureDialogPopup(properties), options);
  }

  downloadButtonClick(
  properties?: DownloadButtonClickProperties,
  options?: EventOptions
  ) {
  return this.track(new DownloadButtonClick(properties), options);
  }

  searchSetups(
  properties?: SearchSetupsProperties,
  options?: EventOptions,
  ) {
  return this.track(new SearchSetups(properties), options);
  }

  selectNavigation(
  properties?: SelectNavigationProperties,
  options?: EventOptions,
  ) {
  return this.track(new SelectNavigation(properties), options);
  }


  saveFavorites(
  properties?: SaveFavoritesProperties,
  options?: EventOptions,
  ) {
    return this.track(new SaveFavorites(properties), options);
  }

  openSetup(
  properties?: OpenSetupProperties,
  options?: EventOptions,
  ) {
    return this.track(new OpenSetup(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
